import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetMarginResponseDtoSchema = z.object({
  margin: z.object({
    currentPct: z.number().nullable(),
    changePct: z.number().nullable(),
  }),
  sparkline: z
    .object({
      granularity: z.string(),
      points: z.array(
        z.object({
          start: z.string(),
          end: z.string(),
          value: z.number().nullable(),
        })
      ),
    })
    .nullable(),
});

const _GetMarginRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

export type GetMarginResponseDto = z.infer<typeof GetMarginResponseDtoSchema>;
export type GetMarginRequestDto = z.infer<typeof _GetMarginRequestDtoSchema>;

export const getMargin = (
  params: GetMarginRequestDto,
  config?: AxiosRequestConfig<GetMarginRequestDto>
) => {
  return api
    .get('facilities/margin', { params, ...config })
    .then(responseContract(GetMarginResponseDtoSchema));
};
